import { HeightRule, Table, TableRow, WidthType, TableLayoutType } from "docx";
import Options from "../../../data/options";
import {
  tableCellMain,
  tableCellMainRight,
  tableCellWithColSpan,
  tableCellWithRowSpan,
  tableCellWithRowSpanBorders,
  tableCellWithTextArray,
  tableCellWithTextArrayExpanded,
} from "./tableCell";
import {
  textbausteinTypes,
  textbausteinTypes1,
} from "../../Textbausteine/textbausteinTypes";
import { getTextbausteinArray } from "./functions";
import Calculations from "../../../helpers/calculations";
import { noten } from "../../../data/noten";

export const mainTable2Brandenburg = (
  user,
  klausur,
  schueler,
  textbausteine
) => {
  return new Table({
    layout: TableLayoutType.FIXED,
    columnWidths: [2500, 6500, 1000],
    width: {
      size: 100,
      type: WidthType.PERCENTAGE,
    },
    rows: [
      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [
          tableCellMain("Kategorie"),
          tableCellMain("Bewertung"),
          tableCellMain("Punkte"),
        ],
      }),
      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [
          tableCellMain(`${textbausteinTypes1.spracheKorrektTb.long}`),
          tableCellWithTextArrayExpanded(
            getTextbausteinArray(schueler.spracheKorrektTb, textbausteine),
            schueler.spracheKorrektRemarks
          ),
          tableCellMain(schueler.spracheKorrektPoints),
        ],
      }),
      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [
          tableCellMain(`${textbausteinTypes1.spracheAusdruckTb.long}`),
          tableCellWithTextArrayExpanded(
            getTextbausteinArray(schueler.spracheAusdruckTb, textbausteine),
            schueler.spracheAusdruckRemarks
          ),
          tableCellMain(schueler.spracheAusdruckPoints),
        ],
      }),
      new TableRow({
        cantSplit: true,
        height: { value: 300, rule: HeightRule.AUTO },
        children: [
          tableCellMain(`${textbausteinTypes1.spracheLesenTb.long}`),
          tableCellWithTextArrayExpanded(
            getTextbausteinArray(schueler.spracheLesenTb, textbausteine),
            schueler.spracheLesenRemarks
          ),
          tableCellMain(schueler.spracheLesenPoints),
        ],
      }),
    ],
  });
};
